import React, { useState } from 'react';
import Select from 'react-select';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="card px-3 py-2">
                    <div className="row">
                        {/* Left Column */}
                        <div className="col-md-6 mt-2 d-flex flex-row gap-1 align-items-baseline">
                            <label className="form-label   text-nowrap mb-0 d-flex flex-grow-1 me-2">Own
                                House</label>
                            <div className="d-flex align-items-baseline mb-0">
                                <input type="checkbox" className="form-check-input me-2" onChange={(e)=> { if
                                (e.target.checked) { setDisableHawbIssuedBy(false) } else { setDisableHawbIssuedBy(true)
                                } }} />

                            </div>
                            <label className="form-label   text-nowrap d-flex flex-grow-1 mb-0">HAWB Issued
                                By</label>
                            <select name="" id="" disabled={disableHawbIssuedBy}
                                className='form-control form-control-sm'>
                                <option value="" selected>Softlink</option>
                            </select>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        HAWB No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" name='order_no' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-0">
                            <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label   mb-0'>
                                    Origin
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Origin1" ,
                                        value: "Origin1" }, { label: "Origin2" , value: "Origin2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Execution Place
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" name='order_no' />
                                    </div>
                                </div>
                                <div className='ms-2 d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Place of Receipt
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Origin1" ,
                                        value: "Origin1" }, { label: "Origin2" , value: "Origin2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">

                            <hr className='mb-1 ' />
                            <h4 className=' text-label-red'>Consol Detail</h4>
                            <hr />

                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Consolidate At
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Delhi" ,
                                        value: "Delhi" }, { label: "Mumbai" , value: "Mumbai" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between align-items-start">
                                {/* Console No. Section */}
                                <div className="d-flex flex-column me-2 flex-grow-1">
                                    <label htmlFor="console-select" className="form-label   mb-1">
                                        Console No.
                                    </label>
                                    <Select id="console-select" className="mt-1 custom-selector" options={[ {
                                        label: "C 1" , value: "C 1" }, { label: "C 2" , value: "C 2" } ]}
                                        defaultValue={{ label: "C 1", value: "C 1" }} />
                                </div>
                                {/* Date Section */}
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="date-input" className="form-label   mb-1">
                                        Date
                                    </label>
                                    <input type="date" id="date-input" className="form-control form-control-sm mt-1"
                                        name="search_by" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between align-items-start">
                                {/* AWB No. Section */}
                                <div className="d-flex flex-column flex-grow-1 me-2">
                                    <label htmlFor="awb-select" className="form-label   mb-1">
                                        AWB No.
                                    </label>
                                    <Select id="awb-select" className="mt-1 custom-selector" options={[ { label: "AWB_1"
                                        , value: "AWB_1" }, { label: "AWB_2" , value: "AWB_2" } ]}
                                        defaultValue={{ label: "AWB_1", value: "AWB_1" }} />
                                </div>
                                {/* Date Section */}
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="date-input" className="form-label   mb-1">
                                        Date
                                    </label>
                                    <input type="date" id="date-input" className="form-control form-control-sm mt-1"
                                        name="search_by" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className="d-flex flex-column flex-grow-1 me-2">
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Place of Exec.
                                    </label>
                                    <div className="icon-forms mt-0 mb-sm-0">
                                        <Select className="mt-2 custom-selector " options={[{ label: "Delhi" ,
                                            value: "Delhi" }, { label: "Mumbai" , value: "Mumbai" }]}
                                            defaultValue={{ label: "Delhi", value: "Delhi" }} />
                                    </div>

                                </div>
                                <div className="d-flex flex-column flex-grow-1">
                                    <label htmlFor="" className='form-label    mb-1'>
                                        Date
                                    </label>
                                    <div className="icon-forms mt-1 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">
                            <hr className='mb-1' />
                            <h4 className='text-label-red '>Co - Load</h4>
                            <hr />
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Origin
                                </label>
                                <div className="icon-forms mt-2 mb-sm-0">
                                    <select className="form-control form-control-sm">
                                        <option value="" selected>Not Applicable</option>
                                        <option value="">In</option>
                                        <option value="">Out</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className='d-flex flex-grow-1 flex-column'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Agent Name
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className="mt-2 custom-selector " options={[{ label: "A 1" , value: "A 1" },
                                        { label: "A 2" , value: "A 2" }]}
                                        defaultValue={{ label: "A 1", value: "A 1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-4">
                            <div className="d-flex justify-content-between align-items-start">
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Agent AWB No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0 me-2">
                                        <input type="text" name="" id="" className='form-control form-control-sm' />
                                    </div>

                                </div>
                                <div className='d-flex flex-grow-1 flex-column'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">
                            <hr className='mb-1' />
                            <h4 className=' text-label-red'>Other Details</h4>
                            <hr />
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label mb-0'>
                                    Lead No.
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "L 1" , value: "L 1" },
                                        { label: "L 2" , value: "L 2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Shipper’s Ref</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <label className="form-label   mb-0">Consignee's Ref</label>
                            <input type="text" className="form-control form-control-sm mt-2" />
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Sales Person
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "SP 1" , value: "SP 1"
                                        }, { label: "SP 2" , value: "SP 2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Business Dims.
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "BD 1" , value: "BD 1"
                                        }, { label: "BD 2" , value: "BD 2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=''>
                                <label htmlFor="" className='form-label   mb-0'>
                                    Movement Type
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <select name="" id="" className='form-control form-control-sm mt-2'>
                                        <option selected>Port to Port</option>
                                        <option>Door to Door</option>
                                        <option>Door to Port</option>
                                        <option>Port to Door</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Origin
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Origin 1" ,
                                        value: "Origin 1" }, { label: "Origin 2" , value: "Origin 2" }]} //
                                        defaultValue={{ label: "Origin1", value: "Origin1" }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Place of Receipt
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "PoR 1" ,
                                        value: "PoR 1" }, { label: "PoR 2" , value: "PoR 2" }]} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Loading Port
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "LP 1" , value: "LP 1"
                                        }, { label: "LP 2" , value: "LP 2" }]} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Discharge Port
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "DP 1" , value: "DP 1"
                                        }, { label: "DP 2" , value: "DP 2" }]} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Place of Delivery
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Place 1" ,
                                        value: "Place 1" }, { label: "Place 2" , value: "Place 2" }]} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Destiation
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Place 1" ,
                                        value: "Place 1" }, { label: "Place 2" , value: "Place 2" }]} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
    <div className=" input_box_section">
        <label htmlFor="trade-lane-select" className="form-label mb-0">
            Trade Lane
        </label>
        <div className="icon-forms mb-3 mb-sm-0">
            <Select
                id="trade-lane-select"
                className="mt-2 custom-selector"
                options={[
                    { label: "Airline 1", value: "Airline 1" },
                    { label: "Airline 2", value: "Airline 2" }
                ]}
            />
        </div>
    </div>
</div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Airline Name
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Airline 1" ,
                                        value: "Airline 1" }, { label: "Airline 2" , value: "Airline 2" }]} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='w-100'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Flight No.
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm" />
                                    </div>

                                </div>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Date
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="date" className="form-control form-control-sm" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='ms-2 input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Incoterms
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select className='mt-2 custom-selector ' options={[{ label: "Incoterms 1" ,
                                        value: "Incoterms 1" }, { label: "Incoterms 2" , value: "Incoterms 2" }]} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="d-flex justify-content-between">
                                <div className='w-100'>
                                    <label htmlFor="" className='form-label   mb-0'>
                                        Freight Currency
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select className='mt-2 custom-selector ' options={[{ label: "CUR 1" ,
                                            value: "CUR 1" }, { label: "CUR 2" , value: "CUR 2" }]} />
                                    </div>

                                </div>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label    mb-0'>
                                        Amount
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-sm mt-2" name='search_by' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className='ms-2 input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Freight
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <select name="" id="" className="form-control form-control-sm">
                                        <option value="" selected>Prepaid</option>
                                        <option value="">Collect</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className=' input_box_section'>
                                <label htmlFor="" className='form-label    mb-0'>
                                    Other Charges
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <select name="" id="" className="form-control form-control-sm">
                                        <option value="" selected>Prepaid</option>
                                        <option value="">Collect</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>

        </div>
    </form>
</>
)
}

export default ShippingDtlsTab